import Modal from 'components/Modal';
import React, { useEffect, useState } from 'react';
import {
	DateRangeWrapper,
	MetadataSummaryLine,
	ModalBody,
	Select,
	SelectWrapper,
	SummaryLabel,
	SummaryValue,
	ValueWrapper,
} from './EditRevenue.styles';
import { MetadataSummary } from 'Settings/ExportMetadataSection/styles';
import { ApInput, ApLoaderDefault } from '@alixpartners/ui-components';
import { getIdealDenomination } from 'utils/number';
import { UNITS } from 'Settings';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import { useContext } from 'react';
import {
	getDateFormat,
	getDateRangeMonthYearSrc,
	getDateRangeMonthYearState,
	getMinMaxDatesFromData,
} from './utils';
import { SettingsOptionsContext } from 'contexts/SettingsOptionsContext';
import { useMemo } from 'react';

const getUnitOptions = () => [
	{
		label: 'None',
		value: 1,
		worth: 1,
	},
	...UNITS.map(unit => ({
		...unit,
		label: unit.value,
	})),
];

const EditRevenue = props => {
	const {
		isFirstTimeEnterRevenue,
		isRevenueSaving,
		revenueData,
		onSaveRevenueYear,
		setIsShowRevenue,
	} = props;
	const { revenue, revenueTo, revenueFrom } = revenueData;
	const allUnitOptions = getUnitOptions();
	const [revenueValue, setRevenueValue] = useState('');
	const [revenueUnit, setRevenueUnit] = useState('');
	const { options } = useContext(SettingsOptionsContext);
	const { dateRanges } = options;
	const { minDate, maxDate } = getMinMaxDatesFromData(dateRanges);
	const wholeRange = getDateRangeMonthYearSrc(minDate, maxDate);
	const selectedRange = getDateRangeMonthYearState(revenueFrom, revenueTo);
	const [dateRangeData, setDateRangeData] = useState({
		srcRange: wholeRange,
		stateRange: selectedRange,
	});
	const minMaxDates = useMemo(() => getDateFormat(dateRangeData.stateRange), [
		dateRangeData.stateRange,
	]);
	useEffect(
		() => {
			if (revenue !== null || revenueTo !== null || revenueFrom !== null) {
				const revenueIdealDenomination = revenue
					? getIdealDenomination(revenue)
					: 1;
				const value = revenue ? revenue / revenueIdealDenomination : '';
				setRevenueValue(value);

				const unitOption = allUnitOptions.find(
					option => option.worth === revenueIdealDenomination
				);
				setRevenueUnit(unitOption.value);
			}
		}, // eslint-disable-next-line
		[revenue]
	);

	const isShowOptions =
		!isRevenueSaving &&
		revenueValue !== '' &&
		revenueFrom !== '' &&
		revenueTo !== '';

	const ModalTitle = isFirstTimeEnterRevenue
		? 'Add revenue & year'
		: 'Update revenue & year';

	const saveRevenueYear = () => {
		const dateRange = minMaxDates;
		const foundOption = allUnitOptions.find(
			option => option.value === revenueUnit
		);
		const data = {
			revenue: parseFloat(revenueValue) * parseInt(foundOption.worth),
			revenueTo: dateRange.dateTo,
			revenueFrom: dateRange.dateFrom,
		};
		onSaveRevenueYear(data);
	};

	const handleDateRangeFilter = e => {
		setDateRangeData(prevState => ({
			...prevState,
			stateRange: e,
		}));
	};

	return (
		<>
			<Modal
				width="620px"
				zIndex="10000000"
				title={ModalTitle}
				cancelLabel={isFirstTimeEnterRevenue ? '' : 'Cancel'}
				submitLabel={isShowOptions ? 'Save' : ''}
				onClose={
					isFirstTimeEnterRevenue ? () => {} : () => setIsShowRevenue(false)
				}
				onSubmit={() => saveRevenueYear()}
			>
				<ModalBody>
					{isRevenueSaving ? (
						<ApLoaderDefault
							loaderText={() => (
								<p style={{ textAlign: 'center' }}>Updating, please wait!</p>
							)}
						/>
					) : (
						<MetadataSummary>
							<MetadataSummaryLine>
								<SummaryLabel>Revenue:</SummaryLabel>
								<SummaryValue>
									<ValueWrapper>
										<ApInput
											type="number"
											name="revenue_value"
											onChange={v => {
												if (isNaN(v) || v === '') {
													setRevenueValue('');
												} else {
													setRevenueValue(parseFloat(v));
												}
											}}
											value={revenueValue === null ? '' : revenueValue}
											shouldStopPropagation
										/>
									</ValueWrapper>
									<SelectWrapper>
										<Select
											name="revenue_unit"
											small
											options={allUnitOptions}
											value={revenueUnit}
											onChange={v => {
												const foundOption = allUnitOptions.find(
													option => option.value === v
												);
												setRevenueUnit(foundOption.value);
											}}
										/>
									</SelectWrapper>
								</SummaryValue>
							</MetadataSummaryLine>
							<MetadataSummaryLine>
								<SummaryLabel>Year:</SummaryLabel>
								<SummaryValue>
									<DateRangeWrapper>
										<MonthPicker
											srcRange={dateRangeData.srcRange}
											stateRange={dateRangeData.stateRange}
											onConfirm={handleDateRangeFilter}
										/>
									</DateRangeWrapper>
								</SummaryValue>
							</MetadataSummaryLine>
						</MetadataSummary>
					)}
				</ModalBody>
			</Modal>
		</>
	);
};

export default EditRevenue;
